import { getData, URLs } from '@common/api';
import * as Product from '@common/models/Product';
import { PayloadAction } from '@reduxjs/toolkit';
import { PRODUCT_CARD_HEIGHT, PRODUCT_CARD_WIDTH } from '@theme/utils/constants';
import { all, call, ForkEffect, put, takeEvery } from 'redux-saga/effects';

import {
  fetchProductListFailure,
  fetchProductListRequest,
  fetchProductListSuccess,
  FetchProductsRequestPayloadType,
} from './slice';

function* fetchProductListSaga({
  payload: { sectionId, useCache, fetchAfterServe, previewQueryLayout },
}: PayloadAction<FetchProductsRequestPayloadType>) {
  try {
    const [{ data }, sectionData] = yield all([
      call(() =>
        getData({
          url: URLs.GET_PRODUCTSLIST.replace('{id}', sectionId),
          useCache,
          fetchAfterServe,
        }),
      ),

      call(() =>
        getData({
          url: URLs.GET_PRODUCTSLIST_SECTION.replace('{id}', sectionId),
          useCache,
          fetchAfterServe,
        }),
      ),
    ]);

    const layout = sectionData?.data?.layout?.name;
    let productDetails = null;
    const productId = data.results[0]?.id;
    if (layout === 'PS13' || previewQueryLayout === 'PS13') {
      const { data } = yield call(() =>
        getData({
          url: URLs.GET_PRODUCT_DETAILS.replace('{id}', productId),
          useCache,
          fetchAfterServe,
        }),
      );
      productDetails = Product.processResponse(data, {
        productCardWidth: PRODUCT_CARD_WIDTH,
        productCardHeight: PRODUCT_CARD_HEIGHT,
      });
    }

    data.results = data.results?.map((product) =>
      Product.processResponse(product, {
        productCardWidth: PRODUCT_CARD_WIDTH,
        productCardHeight: PRODUCT_CARD_HEIGHT,
      }),
    );

    yield put(
      fetchProductListSuccess({
        sectionId,
        products: data,
        productDetails,
        title: sectionData?.data?.title,
        layout: sectionData?.data?.layout,
        showcaseType: sectionData?.data?.showcase_type,
      }),
    );
  } catch (e) {
    yield put(fetchProductListFailure({ sectionId, error: 'Request failed with: ' + e }));
  }
}

export default function* productListSagas(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(fetchProductListRequest.type, fetchProductListSaga);
}
